import { Link } from 'react-router-dom';
import { useVenueProfile } from '../profile-context';

/**
 * Hero panel used on top of the booking / takeout pages. Renders a dark
 * "arcade cabinet" background with an animated grid (CSS only — see
 * brand.css) behind the venue title + slogan. The grid tiles pulse at
 * staggered intervals, giving the page an always-on "the game is live"
 * feel without any JS or asset weight.
 *
 * Accepts optional `subline` override so each page (booking / takeout /
 * status) can set its own sub-heading while keeping the branding block
 * consistent.
 */
interface Props {
  readonly subline?: string;
}

const CELLS = Array.from({ length: 32 });

export function PortalHero({ subline }: Props): JSX.Element {
  const profile = useVenueProfile();
  const showTakeoutLink = profile.capabilities.publicPortal.showTakeoutForm;
  const effectiveSubline = subline ?? profile.branding.availabilityHeadline ?? null;
  return (
    <div className="portal-hero">
      <div className="portal-hero__grid" aria-hidden="true">
        {CELLS.map((_, i) => (
          <span key={i} className="portal-hero__cell" />
        ))}
      </div>
      <div className="portal-hero__body">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <div>
            <h1>{profile.branding.appTitle}</h1>
            <span className="portal-hero__slogan">{profile.branding.tagline}</span>
          </div>
          {showTakeoutLink && (
            <Link to="/takeout" className="portal-hero__takeout">
              外帶 →
            </Link>
          )}
        </div>
        {effectiveSubline && <p className="portal-hero__headline">{effectiveSubline}</p>}
      </div>
    </div>
  );
}
